const LocalStorageKey = {
    SESSION_LAST_ACTIVE: "sla",
};

export default LocalStorageKey;
